import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { addMonths, format } from 'date-fns';
import en from '../../../international/translations/en';
import convertToMonthlyCost from '../../../utils/convertToMonthlyCost';
import { changePlans } from '../../../redux/Cancel/subscription';
import SwitchPlans from '../../../components/Cancel/SwitchPlans';
import OfferConfirmation from '../../../components/Cancel/OfferConfirmation';
import CancelWrapper from '../CancelWrapper/CancelWrapper';

class CancelOffer extends Component {
  static propTypes = {
    params: PropTypes.shape({}).isRequired,
    user: PropTypes.shape({}).isRequired,
    subscription: PropTypes.shape({}).isRequired,
    upcomingInvoice: PropTypes.shape({}),
    changingPlans: PropTypes.bool.isRequired,
    changePlansSuccess: PropTypes.bool.isRequired,
    changePlansError: PropTypes.bool.isRequired,
  };

  static contextTypes = {
    router: PropTypes.object,
  };

  static defaultProps = {
    upcomingInvoice: null,
    changeingPlans: false,
    changePlansSuccess: false,
    changePlansError: false,
  }

  componentWillMount() {
    /**
     * Do not show this page for all users that are
     * in Free Trial or not an Annual subscriber.
     */
    const { subscription, match: { params } } = this.props;
    const sub = subscription.currentSubscriptionForBrand;
    const plan = sub.stripePlanId || sub.planId;
    if (sub.onTrial || plan.indexOf('annual') === -1) {
      this.context.router.history.push(`/cancel/${params.subscriptionId}/verify`);
    }
  }

  componentDidMount() {
    if (window.analytics) {
      window.analytics.page('Cancel Funnel', 'Cancel Offer');
    }
  }

  parseOfferedPlan = () => {
    const offeredPlan = this.props.subscription.offeredPlans[0];
    const monthlyCost = convertToMonthlyCost(
      offeredPlan.amount,
      offeredPlan.interval,
    );
    const fixedMonthlyAmount = parseFloat(monthlyCost / 100).toFixed(2);
    const numberString = fixedMonthlyAmount;
    const decimalIndex = numberString.indexOf('.');
    const dollars = numberString.substring(
      0,
      decimalIndex > -1 ? decimalIndex : numberString.length,
    );
    const cents =
      decimalIndex > -1 ? numberString.substring(decimalIndex + 1) : '';
    const renewalDate = format(addMonths(new Date(), 1), 'MM/DD/YYYY');
    return { fixedMonthlyAmount, renewalDate, dollars, cents };
  };

  acceptOffer = () => {
    const { subscription } = this.props;
    const offeredPlan = subscription.offeredPlans[0];
    const currentSubscription =
      subscription.currentSubscriptionForBrand.subscriptionId;
    this.props.changePlans(offeredPlan.id, currentSubscription);
    return false;
  }

  clickedNoThanks = () => {
    this.context.router.history.push(
      `/cancel/${this.props.match.params.subscriptionId}/verify`,
    );
  };

  render() {
    const text = en.cancellation_funnel;
    const {
      dollars,
      cents
    } = this.parseOfferedPlan();

    const {
      changingPlans,
      changePlansSuccess,
      changePlansError,
      upcomingInvoice,
      user,
    } = this.props;

    return (
      <CancelWrapper splash="offer">
        <Helmet title={text.meta_title_switch_plans} />
        {changePlansSuccess ? (
          <OfferConfirmation
            upcomingInvoice={upcomingInvoice}
            user={user}
          />
        ) : (
          <SwitchPlans
            acceptOffer={() => this.acceptOffer()}
            clickedNoThanks={() => this.clickedNoThanks()}
            changingPlans={changingPlans}
            dollars={dollars}
            cents={cents}
            changePlansError={changePlansError}
          />
        )
        }
      </CancelWrapper>
    );
  }
}

export default connect(
  state => ({
    user: state.user,
    subscription: state.subscription,
    upcomingInvoice: state.subscription.upcomingInvoice,
    changingPlans: state.subscription.changingPlans,
    changePlansSuccess: state.subscription.changePlansSuccess,
    changePlansError: state.subscription.changePlansError,
  }), { changePlans }
)(CancelOffer);
